import { useLocation, useNavigate } from "react-router-dom";
import { clientConfig } from "../../../awsClientConfig";
import { useEffect, useState } from "react";
import { userProfileData } from "../../../Common/profileInfo";
import { GetProfile } from "../../../queries/getProfile";
import { UpdateProfile } from "../../../queries/updateProfile";
import {
  Box,
  Container,
  Divider,
  Switch,
  Typography,
} from "@mui/material";
import "./NotificationsToggleForm.css";
import Message from "../../Message";
import Loading from "../../../Common/Loading";
import Footer from "../../footer";
import "../../../pages/navbar.css";
import AppBreadcrumbs from "../../AppBreadCrumbs";


const NotificationsToggleForm = () => {
  const client = new clientConfig();
  const navigate = useNavigate();
  const { state } = useLocation();
  const [personInfo, setPersonInfo] = useState({});
  const [callEnabled, setCallEnabled] = useState(false);
  const [smsEnabled, setSmsEnabled] = useState(false);
  const [success, setSuccess] = useState("");
  const [loading, setLoading] = useState(true);
  const [isChangeDone, setIsChangeDone] = useState(false);

  useEffect(() => {
    getProfile();
  }, []);

  const getProfile = async () => {
    const profileId = await userProfileData();
    client
      .query({
        query: GetProfile,
        variables: { profileId: profileId },
      })
      .then((res: any) => {
        if (res.data.GetProfile !== null) {
          setPersonInfo(res.data.GetProfile);
          setCallEnabled(res.data.GetProfile.CallEnabled);
          setSmsEnabled(res.data.GetProfile.SmsEnabled);
          setLoading(false);
        }
      })
      .catch((error: any) => {
        console.log(error, "error");
      });
  };

  const submitInfo = async () => {
    const profileId = await userProfileData();
    const variables = {
      ...personInfo,
      Id: profileId,
      CallEnabled: callEnabled,
      SmsEnabled: smsEnabled,
    };
    await client
      .mutate({ mutation: UpdateProfile, variables: variables })
      .then((res: any) => {
        if (res.data.UpdateProfile) {
          console.log("success");
          setCallEnabled(res.data.UpdateProfile.CallEnabled);
          setSmsEnabled(res.data.UpdateProfile.SmsEnabled);
          setSuccess("Updated Notification Information");
          setTimeout(() => {
            setSuccess("");
          }, 5000);
        }
      })
      .catch((error: any) => {
        console.log("error in UpdateProfile", error);
      });
  };

  return (
    <div className="page-container">
      <Container sx={{ mb: 5 }}>

        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            width: "100%",
          }}
        >
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              flexDirection: "column",
              width: "80%",
            }}
          >
            <Box className="headerTitleBox">
              <h1 className="headerTitle">
                Notification & Privacy Preferences
              </h1>
              <AppBreadcrumbs
                items={[
                  { label: 'Home', onClick: () => navigate('/dashboard') },
                  { label: 'Account Settings' },
                  { label: 'Notifications' },
                ]}
              />
            </Box>

            {loading ? (
              <Loading />
            ) : (
              <Box className="formContainerBox">
                <Box padding={"0px 24px 22px 24px"}>
                  <Box padding={"32px 0px 0px 0px"} gap={"11px"}>
                    <Typography
                      sx={{
                        fontWeight: 500,
                        fontSize: "18px",
                        lineHeight: "26px",
                      }}
                    >
                      You can tell us to limit the way we notify you
                    </Typography>
                    <Typography
                      sx={{
                        marginTop: 2,
                        fontWeight: 400,
                        fontSize: "12px",
                      }}
                    >
                      We will use your primary email address to send you notices
                      about your account. You can also opt-in to receive phone
                      calls or text messages.
                    </Typography>
                  </Box>
                  <Divider sx={{ py: 1 }} />
                  <Box
                    sx={{
                      padding: "16px",
                      borderRadius: "8px",
                      boxShadow: "0px 0px 0px 1px #DCDFE4",
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      my: 2,
                    }}
                  >
                    <Typography
                      sx={{
                        fontSize: "16px",
                        fontWeight: 500,
                        lineHeight: "25.12px",
                        color: "#212636",
                      }}
                    >
                      Phone Calls
                    </Typography>
                    <Switch
                      id="PhoneCalls"
                      checked={callEnabled}
                      sx={{
                        "& .MuiSwitch-switchBase.Mui-checked": {
                          color: "#1D89D2",
                        },
                        "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track":
                        {
                          backgroundColor: "#1D89D2",
                        },
                      }}
                      onChange={() => {
                        setIsChangeDone(true);
                        setCallEnabled((prev) => !prev);
                      }}
                      inputProps={{
                        "aria-label": "controlled",
                        color: "#1D89D2",
                      }}
                    />
                  </Box>
                  <Box
                    sx={{
                      padding: "16px",
                      borderRadius: "8px",
                      boxShadow: "0px 0px 0px 1px #DCDFE4",
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      my: 2,
                    }}
                  >
                    <Typography
                      sx={{
                        fontSize: "16px",
                        fontWeight: 500,
                        lineHeight: "25.12px",
                        color: "#212636",
                      }}
                    >
                      Text Messages
                    </Typography>
                    <Switch
                      id="TextMessages"
                      checked={smsEnabled}
                      sx={{
                        "& .MuiSwitch-switchBase.Mui-checked": {
                          color: "#1D89D2",
                        },
                        "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track":
                        {
                          backgroundColor: "#1D89D2",
                        },
                      }}
                      onChange={() => {
                        setIsChangeDone(true);
                        setSmsEnabled((prev) => !prev);
                      }}
                      inputProps={{
                        "aria-label": "controlled",
                        color: "#1D89D2",
                      }}
                    />
                  </Box>
                </Box>
                {success && (
                  <Box
                    padding={"8px 0px 8px 0px"}
                    width={"80%"}
                    marginLeft={"3%"}
                  >
                    <Message type="success" message={success}></Message>
                  </Box>
                )}
                <Box
                  width={"100%"}
                  display={"flex"}
                  justifyContent={"flex-end"}
                  alignItems={"center"}
                  padding={"8px 16px 16px 16px"}
                  gap={"8px"}
                >
                  <button
                    className="cancel-button"
                    onClick={() => navigate("/dashboard")}
                  >
                    Cancel
                  </button>
                  <button
                    disabled={!isChangeDone}
                    className="save-changes-button"
                    onClick={submitInfo}
                  >
                    Save Changes
                  </button>
                </Box>
              </Box>
            )}
          </Box>
        </Box>
      </Container>
      <Footer />
    </div>
  );
};

export default NotificationsToggleForm;
